import React from 'react';
import { Button, InputNumber, Space } from 'antd';
import classnames from 'classnames';
import { getIn } from 'formik';
import PropTypes from 'prop-types';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

import { withTooltip } from '../../../hocs/withTooltip';
import { CustomField } from '../CustomField/CustomField';

import styles from './index.module.css';

export const CustomNumericInput = ({
  field,
  form,
  onChange,
  disabled,
  min,
  max,
  step = 1,
  myclassname,
  name,
  whenFieldDisabledShowTooltip,
  ...rest
}) => {
  const value = field?.value ?? 0;

  const triggerChange = (newValue) => {
    if (newValue === undefined || newValue === null) return;

    if (onChange) {
      onChange({
        name: field?.name,
        value: newValue,
        setFieldValue: form?.setFieldValue,
        values: form?.values,
      });
    } else {
      form?.setFieldValue(field.name, newValue);
    }
  };

  const increment = () => {
    const next = value + step;
    if (max === undefined || next <= max) {
      triggerChange(next);
    }
  };

  const decrement = () => {
    const next = value - step;
    if (min === undefined || next >= min) {
      triggerChange(next);
    }
  };

  return withTooltip(
    <Space>
      <Button
        className={styles.btn}
        icon={<MinusOutlined />}
        onClick={decrement}
        disabled={(min !== undefined && value <= min)}
      />

      <InputNumber
        {...rest}
        name={name || field.name}
        value={value}
        min={min}
        max={max}
        step={step}
        disabled={true}
        onChange={triggerChange}
        className={classnames({
          [styles.numericInput]: true,
          [styles.inputDisabled]: !disabled,
          [styles.error]:
            !disabled &&
            getIn(form?.errors, field?.name) &&
            (getIn(form?.touched, field?.name) || form?.touched[field?.name]),
          [myclassname]: myclassname,
        })}
      />

      <Button
        className={styles.btn}
        icon={<PlusOutlined />}
        onClick={increment}
        disabled={disabled || (max !== undefined && value >= max)}
      />
    </Space>,
    whenFieldDisabledShowTooltip
  );
};

export const NumericInput = ({
  name,
  onChange,
  disabled,
  min,
  max,
  step,
  myClassName,
  whenFieldDisabledShowTooltip,
  fastField,
}) => {
  return (
    <CustomField
      fastField={fastField}
      name={name}
      disabled={disabled}
      onChange={onChange}
      myclassname={myClassName}
    >
      {({ form, field }) => (
        <>
          <CustomNumericInput
            form={form}
            field={field}
            name={name}
            onChange={onChange}
            disabled={disabled}
            min={min}
            max={max}
            step={step}
            myclassname={myClassName}
            whenFieldDisabledShowTooltip={whenFieldDisabledShowTooltip}
          />

          {!disabled &&
            (getIn(form.touched, field.name) || form.touched[field.name]) &&
            getIn(form.errors, field.name) && (
              <div className={styles.errorMessage}>
                {getIn(form.errors, field.name)}
              </div>
            )}
        </>
      )}
    </CustomField>
  );
};

NumericInput.propTypes = {
  name: PropTypes.string.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  myClassName: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  whenFieldDisabledShowTooltip: PropTypes.bool,
  fastField: PropTypes.bool,
};
